import React, { useState, useEffect } from 'react';
import { IoClose } from 'react-icons/io5';
import fnc from '../mymod/commFunction';
import './MaualCategoryAdmin.scss';

const MaualCategoryAdmin = ({ onClose, onSave }) => {
    const [mode, setMode] = useState('list'); // list, create, edit
    const [list, setList] = useState([]);
    const [formData, setFormData] = useState({
        sno: null,
        unit1_code: '',
        unit1_name: '',
        kind: 'manual',
        sort_order: 0,
        useyn: 'Y'
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadList();
    }, []);

    const loadList = () => {
        setLoading(true);
        fnc.sendAxios('/boardRoutes/select_board_unit1', { kind: 'manual', showAll: true }, (res) => {
            if (res && Array.isArray(res)) {
                const newList = res.map(item => ({
                    sno: item["sno"],
                    unit1_code: item["unit1_code"],
                    unit1_name: item["unit1_name"],
                    kind: item["kind"],
                    sort_order: item["sort_order"],
                    useyn: item["useyn"] || 'Y'
                }));
                setList(newList);
            }
            setLoading(false);
        });
    };

    const handleCreate = () => {
        setMode('create');
        const newUnit1Code = `MANUAL_${Date.now()}`;
        setFormData({
            sno: null,
            unit1_code: newUnit1Code,
            unit1_name: '',
            kind: 'manual',
            sort_order: list.length + 1,
            useyn: 'Y'
        });
    };

    const handleEdit = (item) => {
        setMode('edit');
        setFormData({
            sno: item.sno,
            unit1_code: item.unit1_code,
            unit1_name: item.unit1_name,
            kind: item.kind,
            sort_order: item.sort_order || 0,
            useyn: item.useyn || 'Y'
        });
    };

    const handleSave = () => {
        if (!formData.unit1_name.trim()) {
            alert('카테고리명을 입력해주세요.');
            return;
        }

        const endpoint = mode === 'create' 
            ? '/boardRoutes/insert_board_unit1' 
            : '/boardRoutes/update_board_unit1';

        fnc.sendAxios(endpoint, formData, (res) => {
            if (res && res.success) {
                alert(mode === 'create' ? '등록되었습니다.' : '수정되었습니다.');
                setMode('list');
                loadList();
                onSave?.();
            } else {
                alert('저장에 실패했습니다.');
            }
        });
    };

    const handleDelete = (item) => {
        if (!window.confirm(`"${item.unit1_name}" 카테고리를 삭제하시겠습니까?\n\n※ 주의: 해당 카테고리의 모든 하위 항목도 함께 삭제됩니다!`)) {
            return;
        }

        fnc.sendAxios('/boardRoutes/delete_board_unit1', { sno: item.sno }, (res) => {
            if (res && res.success) {
                alert('삭제되었습니다.');
                loadList();
                onSave?.();
            } else {
                alert('삭제에 실패했습니다.');
            }
        });
    };

    const handleCancel = () => {
        setMode('list');
        setFormData({
            sno: null,
            unit1_code: '',
            unit1_name: '',
            kind: 'manual',
            sort_order: 0,
            useyn: 'Y'
        });
    };

    const handleToggleUseyn = (item) => {
        const updated = { ...item, useyn: item.useyn === 'Y' ? 'N' : 'Y' };
        fnc.sendAxios('/boardRoutes/update_board_unit1', updated, (res) => {
            if (res && res.success) loadList();
        });
    };

    const handleMoveUp = (item, index) => {
        if (index === 0) return;
        
        const currentItem = { ...item, sort_order: item.sort_order - 1 };
        const prevItem = { ...list[index - 1], sort_order: list[index - 1].sort_order + 1 };

        Promise.all([
            new Promise((resolve) => {
                fnc.sendAxios('/boardRoutes/update_board_unit1', currentItem, resolve);
            }),
            new Promise((resolve) => {
                fnc.sendAxios('/boardRoutes/update_board_unit1', prevItem, resolve);
            })
        ]).then(() => {
            loadList();
            onSave?.();
        });
    };

    const handleMoveDown = (item, index) => {
        if (index === list.length - 1) return;
        
        const currentItem = { ...item, sort_order: item.sort_order + 1 };
        const nextItem = { ...list[index + 1], sort_order: list[index + 1].sort_order - 1 };

        Promise.all([
            new Promise((resolve) => {
                fnc.sendAxios('/boardRoutes/update_board_unit1', currentItem, resolve);
            }),
            new Promise((resolve) => {
                fnc.sendAxios('/boardRoutes/update_board_unit1', nextItem, resolve);
            })
        ]).then(() => {
            loadList();
            onSave?.();
        });
    };

    return (
        <div className="MaualCategoryAdmin">
            <div className="admin-header">
                <h2>카테고리 관리</h2>
                <button className="btn-close" onClick={onClose}><IoClose /></button>
            </div>

            {mode === 'list' && (
                <div className="admin-content">
                    <div className="content-header">
                        <h3>카테고리 목록</h3>
                        <button className="btn-create" onClick={handleCreate}>
                            + 새 카테고리
                        </button>
                    </div>

                    {loading ? (
                        <div className="loading">로딩 중...</div>
                    ) : (
                        <div className="item-list">
                            {list.length === 0 ? (
                                <div className="empty-message">등록된 카테고리가 없습니다.</div>
                            ) : (
                                <table className="admin-table">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>카테고리명</th>
                                            <th>코드</th>
                                            <th>순서</th>
                                            <th>순서변경</th>
                                            <th>사용</th>
                                            <th>관리</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map((item, index) => (
                                            <tr key={item.sno}>
                                                <td>{index + 1}</td>
                                                <td className="title-cell">{item.unit1_name}</td>
                                                <td className="code-cell">{item.unit1_code}</td>
                                                <td>{item.sort_order}</td>
                                                <td>
                                                    <button 
                                                        className="btn-order"
                                                        onClick={() => handleMoveUp(item, index)}
                                                        disabled={index === 0}
                                                    >
                                                        ▲
                                                    </button>
                                                    <button 
                                                        className="btn-order"
                                                        onClick={() => handleMoveDown(item, index)}
                                                        disabled={index === list.length - 1}
                                                    >
                                                        ▼
                                                    </button>
                                                </td>
                                                <td>
                                                    <button
                                                        className={`btn-useyn ${item.useyn === 'Y' ? 'active' : 'inactive'}`}
                                                        onClick={() => handleToggleUseyn(item)}
                                                    >
                                                        {item.useyn === 'Y' ? 'Y' : 'N'}
                                                    </button>
                                                </td>
                                                <td>
                                                    <button 
                                                        className="btn-edit"
                                                        onClick={() => handleEdit(item)}
                                                    >
                                                        수정
                                                    </button>
                                                    <button 
                                                        className="btn-delete"
                                                        onClick={() => handleDelete(item)}
                                                    >
                                                        삭제
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                </div>
            )}

            {(mode === 'create' || mode === 'edit') && (
                <div className="admin-content">
                    <div className="content-header">
                        <h3>{mode === 'create' ? '새 카테고리 추가' : '카테고리 수정'}</h3>
                        <div className="btn-group">
                            <button className="btn-cancel" onClick={handleCancel}>
                                취소
                            </button>
                            <button className="btn-save" onClick={handleSave}>
                                저장
                            </button>
                        </div>
                    </div>

                    <div className="form-container">
                        <div className="form-row">
                            <label>카테고리명 *</label>
                            <input
                                type="text"
                                value={formData.unit1_name}
                                onChange={(e) => setFormData({...formData, unit1_name: e.target.value})}
                                placeholder="카테고리 이름을 입력하세요"
                            />
                        </div>

                        <div className="form-row">
                            <label>코드</label>
                            <input
                                type="text"
                                value={formData.unit1_code}
                                disabled={mode === 'edit'}
                                onChange={(e) => setFormData({...formData, unit1_code: e.target.value})}
                                placeholder="자동 생성됩니다"
                            />
                            <small className="form-hint">* 코드는 자동으로 생성되며 수정할 수 없습니다.</small>
                        </div>

                        <div className="form-row">
                            <label>순서</label>
                            <input
                                type="number"
                                value={formData.sort_order}
                                onChange={(e) => setFormData({...formData, sort_order: parseInt(e.target.value) || 0})}
                            />
                        </div>

                        <div className="form-row">
                            <label>사용여부</label>
                            <div className="useyn-toggle">
                                <button
                                    type="button"
                                    className={`btn-useyn ${formData.useyn === 'Y' ? 'active' : 'inactive'}`}
                                    onClick={() => setFormData({...formData, useyn: formData.useyn === 'Y' ? 'N' : 'Y'})}
                                >
                                    {formData.useyn === 'Y' ? '사용 (Y)' : '미사용 (N)'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MaualCategoryAdmin;
